export const LOCATION_GET_CACHE_KEY = 'LOCATION_GET_CACHE_KEY';
